module.exports = __webpack_public_path__ + "img/fear-and-greed-dark.229ed15.png";